import {
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
  UPDATE_USER_SUCCESS,
  UPDATE_AVATAR_SUCCESS,
  UPDATE_AVATAR_ERROR,
  INCOMING_MESSAGES_FETCH_SUCCESS,
  INCOMING_MESSAGES_FETCH_ERROR,
  OUTGOING_MESSAGES_FETCH_SUCCESS,
  OUTGOING_MESSAGES_FETCH_ERROR,
  RECEIVED_MESSAGES_FETCH_SUCCESS,
  RECEIVED_MESSAGES_FETCH_ERROR,
  SENT_MESSAGES_FETCH_SUCCESS,
  SENT_MESSAGES_FETCH_ERROR,
  // REFRESH_TOKEN_ERROR,
  REFRESH_TOKEN_SUCCESS,
  REFRESHING_TOKEN,
  REFRESHING_TOKEN_DONE,
} from '../actions/types';

const INITIAL_STATE = {};

const currentUserReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return action.payload;
    case LOGIN_ERROR:
      return INITIAL_STATE;
    case LOGOUT_SUCCESS:
      return { ...state, success: false };
    case LOGOUT_ERROR:
      return state;
    case REFRESHING_TOKEN:
      return { ...state, token: { ...state.token, refreshing: true } };
    case REFRESHING_TOKEN_DONE:
      return { ...state, token: { ...state.token, refreshing: false } };
    case REFRESH_TOKEN_SUCCESS:
      return { ...state, token: action.payload };
    case UPDATE_USER_SUCCESS:
      return { ...state, user: action.payload };
    case UPDATE_AVATAR_SUCCESS:
      return { ...state, user: action.payload };
    case UPDATE_AVATAR_ERROR:
      return state;
    case INCOMING_MESSAGES_FETCH_SUCCESS:
      return { ...state, incomingMessageCount: action.payload };
    case INCOMING_MESSAGES_FETCH_ERROR:
      return state;
    case OUTGOING_MESSAGES_FETCH_SUCCESS:
      return { ...state, outgoingMessageCount: action.payload };
    case OUTGOING_MESSAGES_FETCH_ERROR:
      return state;
    case RECEIVED_MESSAGES_FETCH_SUCCESS:
      return { ...state, receivedMessageCount: action.payload };
    case RECEIVED_MESSAGES_FETCH_ERROR:
      return state;
    case SENT_MESSAGES_FETCH_SUCCESS:
      return { ...state, sentMessageCount: action.payload };
    case SENT_MESSAGES_FETCH_ERROR:
      return state;
    default:
      return state;
  }
};

export default currentUserReducer;
